<svg
  class={$$restProps.class}
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 32 32"
  ><path
    d="M16.32 13.71v5.49h9.08c-.37 2.35-2.75 6.9-9.08 6.9-5.46 0-9.92-4.52-9.92-10.1s4.46-10.1 9.92-10.1a9 9 0 016.38 2.46l4.34-4.18A15.35 15.35 0 0016.32 0c-8.85 0-16 7.15-16 16s7.15 16 16 16c9.23 0 15.36-6.49 15.36-15.63 0-1.06-.11-1.86-.25-2.66z"
  /></svg
>
